export default __webpack_public_path__ + "static/media/no-maches.96d9b83a.jpg";